export var root='/email';export default{root:root,list:'/email/:module',detail:'/email/:module/:id'};